import Repository from './Repository'

export default {
  changePassword(formData) {
    return Repository.private().put(`/user/change-password/`, formData)
  },
  updatePasswordFirstTime(formData) {
    return Repository.private().put(`/user/new-password/`, formData)
  },
  resetPasswordSendEmail(formData) {
    return Repository.public().post(`/user/reset-password/`, formData)
  },
  resetPassword(formData) {
    return Repository.public().post(`/user/reset-password/confirm/`, formData)
  }
}